import ClipText from "@components/ClipText/ClipText";
import Image from "@components/Image";
import cx from "classnames";
import React from "react";
import styles from "./Exhibitions.module.scss";
import Button from "@components/Button";
import _ from "lodash";
interface Props {
  data: {
    image: {
      src: string;
      alt: string;
    };
    subtitle: string;
    title: string;
    content: string | React.ReactNode;
    actionMore: string | React.ReactNode;
    button: {
      label: string;
      href: string;
    };
  };
}

export default function Item({ data }: Props) {
  return (
    <div className={cx(styles.item)}>
      <Image
        {..._.get(data, "image")}
        alt={_.get(data, "image.alt") || data.title || "Exhibition image"}
        wrapperProps={{ className: cx(styles.image) }}
        layout="fill"
        objectFit="cover"
      />
      <ClipText fixedRows rows={1} className={cx(styles.subtitle)}>
        {data.subtitle}
      </ClipText>
      <ClipText rows={2} className={cx(styles.title)}>
        {data.title}
      </ClipText>
      <ClipText fixedRows rows={6} className={cx(styles.content)}>
        {data.content}
      </ClipText>
      <Button
        type="icon"
        suffix="shape-arrow"
        className={cx(styles.actionMore, "mt-auto")}
        label={_.get(data, "button.label")}
        onClick={() => {
          location.href = _.get(data, "button.href");
        }}
      />
    </div>
  );
}
